import { selectExperiments } from './experiments';
import { DAILY_RENT_OTA_CONVERSION } from '../../constants/config';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

export const selectIsDailyRentOtaConversionExperimentActive = (state: IApplicationState): boolean => {
  const experiments = selectExperiments(state);

  // эксперимент нацелен на группу = B
  const bGroup = isAbUseExperimentActive(experiments, DAILY_RENT_OTA_CONVERSION, 'B');

  return bGroup;
};
